<template>
  <div class="main">
    <div>
      <h2 class="locked-drop-label">
        This {{ type }} is protected.
      </h2>
    </div>
    <div>
      <rails-b-form inline @submit.prevent="submitForm" ref="form">
        <label class="sr-only" for="input-password">Password</label>
        <b-form-input
          type="password"
          name="password"
          placeholder="Enter Password"
          id="input-password"
          class="input-password"
          v-model="password"
        ></b-form-input>
        <b-button
          type="submit"
          variant="primary"
          class="button-password"
        >
          Unlock
        </b-button>
      </rails-b-form>
    </div>
  </div>
</template>

<script>
import RailsBForm from "@/src/components/rails_b_form.vue";

export default {
  components: { RailsBForm },
  props: {
    id: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true
    }
  },
  data: function () {
    return {
      password: "",
    };
  },
  computed: {
    verifyPasswordUrl: function() { 
      return (this.type == "collection" ? this.$root.routes.verify_password_collection_path(this.id) : this.$root.routes.viewer_verify_password_path(this.id));
    },
    linkedItemUrl: function() {
      return (this.type == "collection" ? this.$root.routes.collection_path(this.id) : this.$root.routes.viewer_view_item_path(this.id));
    }
  },
  methods: {
    submitForm() {
      const vm = this;
      const url = vm.verifyPasswordUrl;

      vm.$refs.form.submit(url).then((response) => {
        const token = response.data.token;
        let params = new URLSearchParams("")
        let path = vm.linkedItemUrl;

        params.append("pwt", token);
        path = path + "?" + params.toString();

        window.location = path;
      }).catch((error) => {
        vm.$root.toastError(error.response?.data?.message || error?.message || "Something went wrong");
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "application.scss";

.main {
  display: flex;
  flex-direction: column;
  position: absolute;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: rgb(33, 37, 41);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
}

h2.locked-drop-label {
  font-size: 2rem;
  font-weight: 300;
  line-height: 38.4px;
  margin-bottom: 32px;
  margin-top: 0px;
  text-align: center;
  color: var(--gray);
}

.input-password {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.button-password {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}



</style>
